<!-- <app-header [title]="Title"></app-header> -->
<p>
  
  <!-- <iframe _ngcontent-irq-c2="" height="700px" src="https://app.powerbi.com/view?r=eyJrIjoiZWFhYjI1MjQtZmFjYS00MDg1LWIyYTgtOTdkYTNlMTEwN2M0IiwidCI6ImE0ZTU2MTU2LTRjYjQtNGVjMS04ZWFlLThlYjI0Y2VjYjc3MCIsImMiOjZ9" width="100%"></iframe> -->
  <iframe _ngcontent-irq-c2="" height="700px" [src]="urlSafe" width="100%"></iframe>
</p>
